import { render, staticRenderFns } from "./SelectEvidenceModal.vue?vue&type=template&id=f437d4f2&scoped=true&"
import script from "./SelectEvidenceModal.vue?vue&type=script&lang=js&"
export * from "./SelectEvidenceModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectEvidenceModal.vue?vue&type=style&index=0&id=f437d4f2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f437d4f2",
  null
  
)

export default component.exports